<div class="content-layout-v2" [ngClass]="{ mobile: isMobileLayout }">
  <div
    class="dropdown"
    [ngClass]="{ expanded: isExpanded }"
    [hidden]="!isMobileLayout"
  >
    <div class="dropdown-list-of-items custom-scroll" [hidden]="!isExpanded">
      <ng-container *ngTemplateOutlet="start"></ng-container>
    </div>
    <div
      (click)="toggleListViewExpansion()"
      class="mobile-expand-button"
      [ngClass]="{ 'row-1': isExpanded, 'col-2': !isExpanded }"
    >
      <svg-icon
        src="../../../assets/images/icons/drop_down_arrow.svg"
        [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"
        [ngClass]="{ expanded: isExpanded }"
      ></svg-icon>
    </div>
  </div>

  <!-- LIST OF LOADED ITEMS *DESKTOP ONLY -->
  <div class="start border-end custom-scroll" [hidden]="isMobileLayout">
    <ng-container *ngTemplateOutlet="start"></ng-container>
  </div>

  <!-- DETAILED VIEW OF DATA -->
  <div
    class="center border-end custom-scroll overflow-hidden"
    [ngClass]="{ mobile: isMobileLayout }"
  >
    <ng-container *ngTemplateOutlet="center"></ng-container>
  </div>

  <!-- SCROLL SPY *DESKTOP ONLY -->
  <div class="end custom-scroll" [hidden]="isMobileLayout">
    <ng-container *ngTemplateOutlet="end"></ng-container>
  </div>
</div>
